<script setup lang="ts">
import type { Icon } from '../HugeIcon/huge-icon';
import HugeIcon from '../HugeIcon/HugeIcon.vue';
import TTooltip from '../TTooltip.vue';
import { computed } from 'vue';

const props = defineProps<{
  icon: Icon;
  size?: 'md' | 'sm';
  variant?: 'primary' | 'neutral' | 'ghost-primary' | 'ghost-neutral';
  tooltip?: string;
  tooltipMaxWidth?: number;
  disabled?: boolean;
  loading?: boolean;
}>();

const emits = defineEmits<{
  click: [e: MouseEvent];
}>();

const variant = computed(() => props.variant ?? 'primary');
</script>

<template>
  <TTooltip
    :content="props.tooltip"
    :max-width="props.tooltipMaxWidth"
    placement="top"
  >
    <button
      :disabled="props.disabled || props.loading"
      class="disabled:cursor-not-allowed disabled:opacity-50"
      v-bind="$attrs"
      :class="[
        'inline-flex items-center justify-center gap-1 rounded-lg font-semibold transition-all duration-300',
        props.size === 'md' ? 'text-md h-10 w-10' : 'h-8 w-8 text-sm',
        variant === 'primary' &&
          'bg-gradient-to-tr from-violet-600 to-indigo-600 text-white shadow-[0_4px_15px_rgba(147,51,234,0.4)] ease-[cubic-bezier(0.4,0,0.2,1)] hover:translate-y-[-1px] hover:shadow-[0_8px_25px_rgba(147,51,234,0.5)] hover:brightness-110 active:translate-y-[1px] active:shadow-[0_2px_10px_rgba(147,51,234,0.3)]',
        variant === 'neutral' &&
          'border border-slate-200 bg-slate-50 text-slate-800',
        variant === 'ghost-primary' && 'text-primary-500 hover:bg-primary-50',
        variant === 'ghost-neutral' &&
          'text-slate-600 hover:bg-neutral-50 hover:text-neutral-800',
      ]"
      @click="(e) => emits('click', e)"
    >
      <HugeIcon
        :spin="props.loading"
        :icon="props.loading ? 'loading' : props.icon"
        :size="props.size === 'sm' ? 20 : 24"
      />
    </button>
  </TTooltip>
</template>
